import { mapState } from 'vuex'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'

export default {
  name: 'ShiftTable',
  components: {
    IcEdit
  },
  props: {
    shifts: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      adminShiftStatuses: state => state.sharedData.adminShiftStatuses
    })
  },
  methods: {
    goToReport(adminShiftId) {
      this.$router.push({
        name: 'shift-report',
        params: {
          id: adminShiftId
        }
      })
    }
  }
}